<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter01">
<a id="page06">
</a><a id="page07">
</a><a id="page08">
</a><a id="page1">
</a><div class="chapterHead"><a id="page1">
</a><h2 class="chapterTitle"><a id="page1"><span class="xrefInternal"></span></a><a href="#/004TOC#chapter_01"><span class="bold">SKIDMARKS</span></a></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">The first one catches my eye</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">as I fly down the freeway rushing</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">to get to the doctor’s office on time</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">and pretty soon that’s all I can see—</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">streaming across the pavement</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">in blurred black streaks</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">as though</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">the road’s mascara</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">is running.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">I don’t want to fixate</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">on these desperate claw marks,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">these permanent records of calamity,</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">but I can’t seem</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">to stop myself</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">from staring at them</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">any more than I can stop myself</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">from careening toward</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">my fiftieth birthday—</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">the one that’s rushing at me</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">like a cinderblock wall while I try</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">in vain to slam on my brakes.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005-chapter01.vue?b0116c9e